/**
 * @generated SignedSource<<0748082d79c6217034dd8f484a2114e3>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type CarouselThumb_viewInRoomPhoto$data = {
  readonly credits: string | null;
  readonly src: string | null;
  readonly " $fragmentType": "CarouselThumb_viewInRoomPhoto";
};
export type CarouselThumb_viewInRoomPhoto$key = {
  readonly " $data"?: CarouselThumb_viewInRoomPhoto$data;
  readonly " $fragmentSpreads": FragmentRefs<"CarouselThumb_viewInRoomPhoto">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "CarouselThumb_viewInRoomPhoto",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "src",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "credits",
      "storageKey": null
    }
  ],
  "type": "viewInRoomPhotos",
  "abstractKey": null
};

(node as any).hash = "4da1e7eb78e2fa382e7f23aeb8f01315";

export default node;
